import { lazy } from "react";

export const HomePage = lazy(() => import("./HomePage"));
export const LessonsPage = lazy(() => import("./LessonsPage"));
export const StudentLessonPage = lazy(() => import("./StudentLessonPage"));
export const LoginPage = lazy(() => import("./Login"));
export const LoginWithCodePage = lazy(() => import("./LoginWithCode"));
export const ForgotPasswordPage = lazy(() => import("./ForgotPassword"));
export const ForgotPasswordWithCode = lazy(() => import("./ForgotPasswordWithCode"));
export const StudentsPage = lazy(() => import("./StudentsPage"));
export const InstructorsPage = lazy(() => import("./InstructorsPage"));
export const LessonsDetailsPage = lazy(() => import("./LessonsDetailsPage"));
export const ProfilePage = lazy(() => import("./ProfilePage"));
export const SettingsPage = lazy(() => import("./SettingsPage"));
export const AssignmentSubmissions = lazy(
  () => import("./AssignmentSubmissions"),
);
export const SubjectsPage = lazy(() => import("./SubjectsPage"));
export const SubjectLessonsPage = lazy(() => import("./SubjectLessonsPage"));
export const StudentAssignmentPage = lazy(
  () => import("./StudentAssignmentPage"),
);
export const LiveClassPage = lazy(() => import("./LiveClassPage"));
